<template>
    <div class="single_small_soproni_box_area">
        <div class="row">
            <div class="col-sm-12">
                <div class="single_small_soproni_box_cont_all">
                    <div class="row">

                        <template v-if="products != null">
                            <product-list-view v-for="p in products" :product="p" :key="p.id"></product-list-view>
                        </template>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <div class="up-div" v-if="suv">
                    <a @click="toTop" style="color:white"><i class="fa fa-chevron-up fa-3x"></i></a>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import ProductListView from '@pages/list/ProductListView.vue'

export default{
    components:{
        ProductListView
    },
    data:function () {
        return {
            suv: false,
        };
    },
    props:['products'],
    created:function () {
        var self = this;
        $(window).scroll(function (event) {
            var scroll = $(window).scrollTop();
            if(scroll>200){
                self.suv = true;
            }else{
                self.suv = false;
            }
        });
    },
    beforeDestroy:function () {
        $(window).unbind('scroll');
    },
    methods:{
        toTop(){
            $("html, body").animate({ scrollTop: 0 }, "slow");
        },
        scrolled(e){
        }
    }
}
</script>

<style scoped>
.row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display:         flex;
  flex-wrap: wrap;
}
.row > [class*='col-'] {
  display: flex;
  flex-direction: column;
}
.up-div{
    position: fixed;
    bottom: 30px;
    right: 30px;

}

.row.container:before,
.row.container:after,
.row.row:before,
.row.row:after {
   content: normal;
}
</style>



// WEBPACK FOOTER //
// Products.vue?a8b3838c